import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./Context/UserContext";
import { NavigationProvider } from "./Context/NavigationContext";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    {/* Wrap your App component with UserContextProvider */}
    <AuthProvider>
      <NavigationProvider>
        <App />
      </NavigationProvider>
    </AuthProvider>
  </React.StrictMode>
);
